module.exports = __webpack_public_path__ + "static/img/chuguanbg.9580ac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuguanbg.jpg
// module id = SVpv
// module chunks = 1